export interface UpdateCrateDto {
  /**
   *
   * @type {string}
   * @memberof UpdateCrateDto
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateCrateDto
   */
  description?: string;
  /**
   *
   * @type {Date}
   * @memberof UpdateCrateDto
   */
  published?: Date;
  /**
   *
   * @type {Array<string>}
   * @memberof UpdateCrateDto
   */
  hacker?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof UpdateCrateDto
   */
  status?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof UpdateCrateDto
   */
  category?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof UpdateCrateDto
   */
  live?: boolean;
  /**
   *
   * @type {string}
   * @memberof UpdateCrateDto
   */
  image?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateCrateDto
   */
  playlistID?: string;
  /**
   *
   * @type {Array<object>}
   * @memberof UpdateCrateDto
   */
  tracks?: Array<object>;
  /**
   *
   * @type {string}
   * @memberof UpdateCrateDto
   */
  type?: string;
  /**
   *
   * @type {boolean}
   * @memberof UpdateCrateDto
   */
  rekordcloud?: boolean;
  /**
   *
   * @type {string}
   * @memberof UpdateCrateDto
   */
  facebookLiveEmbed?: string;
  /**
   *
   * @type {boolean}
   * @memberof UpdateCrateDto
   */
  vDJ?: boolean;
  /**
   *
   * @type {string}
   * @memberof UpdateCrateDto
   */
  streamAppleMusic?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateCrateDto
   */
  streamBeatsource?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateCrateDto
   */
  streamDeezer?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateCrateDto
   */
  streamSoundcloud?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateCrateDto
   */
  streamSpotify?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateCrateDto
   */
  streamTidal?: string;
  /**
   *
   * @type {number}
   * @memberof UpdateCrateDto
   */
  groupId?: number;

  /**
   *
   * @type {number}
   * @memberof UpdateCrateDto
   */
  viewCount?: number;

  /**
   *
   * @type {number}
   * @memberof UpdateCrateDto
   */
  saveCount?: number;

  /**
   *
   * @type {string}
   * @memberof UpdateCrateDto
   */
  locationFrom?: string;

  /**
   * Array of user IDs who have saved to Spotify via Cloud Crates
   * @type {Array<string>}
   * @memberof UpdateCrateDto
   */
  cloudCrateSpotify?: Array<string>;

  /**
   * Array of user IDs who have saved to Apple Music via Cloud Crates
   * @type {Array<string>}
   * @memberof UpdateCrateDto
   */
  cloudCrateApple?: Array<string>;

  /**
   * Array of user IDs who have saved to Tidal via Cloud Crates
   * @type {Array<string>}
   * @memberof UpdateCrateDto
   */
  cloudCrateTidal?: Array<string>;

  /**
   * Embed code for video (iframe HTML)
   * @type {string}
   * @memberof UpdateCrateDto
   */
  videoEmbedCode?: string;
}

export function UpdateCrateDtoToJSON(value?: UpdateCrateDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    Title: value.title,
    Description: value.description,
    Published:
      value.published === undefined ? undefined : value.published.toISOString(),
    Hacker: value.hacker,
    Status: value.status,
    Category: value.category,
    Live: value.live,
    Image: value.image,
    PlaylistID: value.playlistID,
    Tracks: value.tracks,
    Type: value.type,
    Rekordcloud: value.rekordcloud,
    FacebookLiveEmbed: value.facebookLiveEmbed,
    VDJ: value.vDJ,
    StreamAppleMusic: value.streamAppleMusic,
    StreamBeatsource: value.streamBeatsource,
    StreamDeezer: value.streamDeezer,
    StreamSoundcloud: value.streamSoundcloud,
    StreamSpotify: value.streamSpotify,
    StreamTidal: value.streamTidal,
    groupId: value.groupId,
    viewCount: value.viewCount,
    saveCount: value.saveCount,
    locationFrom: value.locationFrom,
    CloudCrateSpotify: value.cloudCrateSpotify,
    CloudCrateApple: value.cloudCrateApple,
    CloudCrateTidal: value.cloudCrateTidal,
    videoEmbedCode: value.videoEmbedCode,
  };
}
